import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Navigation.css';

function Navigation() {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (
    <header className="page-header">
      <nav>
        <Link to="/" onClick={closeMenu} className="logo">LoDis Signals</Link>
        <button className={`hamburger ${menuOpen ? 'active' : ''}`} onClick={toggleMenu} aria-label="Toggle menu">
          <span></span>
          <span></span>
          <span></span>
        </button>
        <ul className={`nav-menu ${menuOpen ? 'active' : ''}`}>
          <li><Link to="/" onClick={closeMenu}>Home</Link></li>
          <li><Link to="/info" onClick={closeMenu}>Info</Link></li>
          <li><Link to="/signals-firmware" onClick={closeMenu}>Firmware</Link></li>
          <li><Link to="/orders" onClick={closeMenu}>Orders</Link></li>
        </ul>
      </nav>
    </header>
  );
}

export default Navigation;
